import Alpine from 'alpinejs'
import Chart from 'chart.js/auto'

document.addEventListener('alpine:init', () => {
  Alpine.data('heatDemandScenarioWeather', () => {
    let hddChart
    let hddData // To hold chart data
    let oatChart
    let oatData
    let solarRadiationChart
    let solarRadiationData

    return {
      selectedYear: '2020',
      selectedReferenceYear: 'cibse',
      data: null,

      init () {
        fetch('./weather.json').then(response => response.json()).then(data => {
          this.data = data
        })
        // Initialise the charts
        hddChart = new Chart(document.getElementById('hddChart'), {
          type: 'bar',
          options: {
            maintainAspectRatio: false,
            indexAxis: 'y',
            plugins: {
              legend: {
                display: false
              }
            },
            scales: {
              y: {
                title: {
                  display: true,
                  text: 'Reference City'
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'HDD'
                }
              }
            }
          }
        })
        hddData = document.getElementById('hddChart-data')

        oatChart = new Chart(document.getElementById('oatChart'), {
          type: 'line',
          options: {
            maintainAspectRatio: false,
            interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false
            },
            elements: {
              line: {
                tension: 0.4,
                borderWidth: 1
              }
            },
            plugins: {
              legend: {
                position: 'right',
                align: 'start'
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Number of hours'
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Temperature (°C)'
                }
              }
            }
          }
        })
        oatData = document.getElementById('oatChart-data')

        solarRadiationChart = new Chart(document.getElementById('solarRadiationChart'), {
          type: 'line',
          options: {
            maintainAspectRatio: false,
            interaction: {
              mode: 'nearest',
              axis: 'x',
              intersect: false
            },
            elements: {
              line: {
                tension: 0.4,
                borderWidth: 1
              },
              point: {
                radius: 0
              }
            },
            plugins: {
              legend: {
                position: 'right',
                align: 'start'
              },
              tooltip: {
                callbacks: {
                  label: context => {
                    const label = context.dataset.label || ''
                    const value = context.parsed.y || 0
                    return `${label}: ${Math.round(value)} kW/m²`
                  }
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Solar Radiation (kW/m²)'
                }
              },
              x: {
                title: {
                  display: true,
                  text: 'Date'
                }
              }
            }
          }
        })
        solarRadiationData = document.getElementById('solarRadiationChart-data')

        Alpine.effect(() => {
          const selectedYear = this.selectedYear
          if (!this.data) return

          const hddDataset = this.data.hdd.filter(entry => entry.Year === selectedYear)?.map(entry => entry.HDD)
          hddChart.data.labels = this.data.cities
          hddChart.data.datasets = [{ label: 'HDD', data: hddDataset }]
          hddChart.update()
          hddData.value = JSON.stringify(hddChart.data)

          const oatDatasets = this.data.cities.map(city => ({ label: city, data: [] }))
          this.data.oatHist.filter(entry => entry.Year === this.selectedYear).forEach(entry => {
            // Assume the data values are in the same order as the labels (as processed on server)
            oatDatasets.find(dataset => dataset.label === entry.City).data.push(entry.OAT)
          })
          oatChart.data.labels = this.data.oatLabels
          oatChart.data.datasets = oatDatasets
          oatChart.update()
          oatData.value = JSON.stringify(oatChart.data)

          const solarRadiationDatasets = this.data.cities.map(city => ({ label: city, data: [] }))
          this.data.monthlySolarRadiation.filter(entry => entry.Year === this.selectedYear).forEach(entry => {
            // Assume the data values are in the same order as the labels (as processed on server)
            solarRadiationDatasets.find(dataset => dataset.label === entry.City).data.push(entry.SolarRadiation)
          })
          solarRadiationChart.data.labels = this.data.monthlySolarRadiationLabels.map(label => new Date(label).toLocaleDateString())
          solarRadiationChart.data.datasets = solarRadiationDatasets
          solarRadiationChart.update()
          solarRadiationData.value = JSON.stringify(solarRadiationChart.data)
        })
      }
    }
  })
})
